import React, { Component } from "react";
import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import { connect } from "react-redux";

// components

import Home from "./components/HomePage";
import Details from "./components/DetailsPage";
import List from "./components/ListPage";
import Basket from "./components/BasketPage";
import Connexion from "./components/ConnexionPage";

const history = createBrowserHistory();

class ConnectedApp extends Component {
  render() {
    return (
      <div>
        <Router history={history}>
          <Route exact path="/" component={Home} />
          <Route exact path="/list" component={List} />
          <Route exact path="/product/:id" component={Details} />
          <Route exact path="/basket" component={Basket} />
          <Route exact path="/connexion" component={Connexion} />
        </Router>
      </div>
    );
  }
}

const App = connect(
  null,
  null
)(ConnectedApp);

export default App;
